// src/components/purchase/MarcarPagadaModal.js
// Modal de confirmación para marcar factura como pagada

import React, { useState } from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import { useAuth } from '../../context/AuthContext';
import { updatePurchaseStatus, getStatusCompras } from '../../services/purchaseApi';
import './MarcarPagadaModal.css';

const MarcarPagadaModal = ({ show, onHide, purchaseId, purchaseReference, onSuccess }) => {
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');

  const handleConfirm = async () => {
    if (!purchaseId || !user?.uid) return;
    setErrorMsg('');
    setLoading(true);
    try {
      const statusRes = await getStatusCompras();
      if (!statusRes.ok || !Array.isArray(statusRes.data)) {
        setErrorMsg('No se pudo obtener el estado PAGADA.');
        setLoading(false);
        return;
      }
      const pagada = statusRes.data.find(
        (s) =>
          (s.status_name || s.name || '').toUpperCase() === 'PAGADA' ||
          (s.status_code || s.code || '').toUpperCase() === 'PAGADA'
      );
      if (!pagada?.id_status) {
        setErrorMsg('Estado PAGADA no encontrado.');
        setLoading(false);
        return;
      }
      const { ok, data } = await updatePurchaseStatus(purchaseId, {
        firebase_UID: user.uid,
        id_status: pagada.id_status
      });
      if (ok) {
        onSuccess?.();
        onHide();
      } else {
        setErrorMsg(data?.message || 'Error al marcar como pagada.');
      }
    } catch {
      setErrorMsg('Error inesperado.');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (!loading) {
      setErrorMsg('');
      onHide();
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered className="marcar-pagada-modal" backdrop="static">
      <Modal.Header className="marcar-pagada-modal-header">
        <Modal.Title>Marcar como pagada</Modal.Title>
        <button
          type="button"
          className="btn-close btn-close-white"
          aria-label="Cerrar"
          onClick={handleClose}
        />
      </Modal.Header>
      <Modal.Body className="marcar-pagada-modal-body">
        {errorMsg && <div className="marcar-pagada-error">{errorMsg}</div>}
        <p className="marcar-pagada-message">
          ¿Marcar esta factura{purchaseReference ? ` #${purchaseReference}` : ''} como pagada?
        </p>
      </Modal.Body>
      <Modal.Footer className="marcar-pagada-modal-footer">
        <Button variant="outline-secondary" onClick={handleClose} disabled={loading}>
          Cancelar
        </Button>
        <Button className="marcar-pagada-btn-confirm" onClick={handleConfirm} disabled={loading}>
          {loading ? <Spinner animation="border" size="sm" /> : 'Confirmar'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default MarcarPagadaModal;
